import { getChainById } from './getChainById';

export const getContractUrl = (chainId?: number, contractAddress?: string): string => {
  const chain = getChainById(chainId);
  const blockExplorerUrl = chain?.blockExplorers?.default.url;

  if (!blockExplorerUrl || !contractAddress) {
    return '#';
  }

  return `${blockExplorerUrl}/address/${contractAddress}`;
};
